<template>
  <div class="unified-login-container">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="floating-shape shape-1"></div>
      <div class="floating-shape shape-2"></div>
      <div class="floating-shape shape-3"></div>
      <div class="floating-shape shape-4"></div>
    </div>

    <div class="login-wrapper">
      <div class="login-card">
        <!-- 返回按钮 -->
        <div class="back-btn">
          <el-button icon="el-icon-arrow-left" @click="$router.push('/')" type="text">
            返回首页
          </el-button>
        </div>

        <!-- 标题区域 -->
        <div class="login-header">
          <h2>系统登录</h2>
          <p>永盛制冷维修有限公司-家电售卖与维修</p>
        </div>

        <!-- 登录表单 -->
        <el-form 
          ref="loginForm" 
          :model="loginForm" 
          :rules="loginRules" 
          label-width="0"
          @submit.native.prevent="handleLogin"
          class="login-form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              size="large"
            />
          </el-form-item>
          
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              show-password
            />
          </el-form-item>
          
          <el-form-item>
            <el-button 
              type="primary"
              size="large" 
              style="width: 100%"
              :loading="$store.state.loading"
              @click="handleLogin"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 注册链接 -->
        <div class="login-footer">
          <p>
            还没有账号？
            <router-link to="/customer/register">立即注册</router-link>
          </p>
        </div>

        <!-- 用户类型提示 -->
        <div class="user-type-hint">
          <p>支持客户、工人、管理员登录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnifiedLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    console.log('[前端] UnifiedLogin组件已挂载')
  },
  methods: {
    async handleLogin() {
      try {
        await this.$refs.loginForm.validate()
        
        console.log('[前端] 开始统一登录验证')
        
        // 调用后端统一登录接口
        const result = await this.unifiedLogin()
        
        if (result.success) {
          this.$message.success('登录成功')
          // 根据返回的用户类型跳转到对应的主页
          const targetPath = `/${result.userType}/home`
          console.log('[前端] 登录成功，跳转到:', targetPath)
          this.$router.push(targetPath)
        } else {
          this.$message.error(result.message || '登录失败')
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error('登录失败，请检查用户名和密码')
      }
    },
    
    async unifiedLogin() {
      try {
        this.$store.commit('SET_LOADING', true)
        
        console.log('[前端] 统一登录请求:', { username: this.loginForm.username })
        
        const response = await this.$http.post('/api/auth/unified-login', {
          username: this.loginForm.username,
          password: this.loginForm.password
        })
        
        console.log('[前端] 统一登录响应:', response)
        
        if (response.success) {
          const { user, token, userType } = response.data
          
          // 存储到localStorage
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('userType', userType)
          
          // 设置axios默认header
          this.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
          
          // 更新store状态
          this.$store.commit('SET_USER', user)
          this.$store.commit('SET_TOKEN', token)
          
          return { success: true, user, userType }
        } else {
          return { success: false, message: response.message }
        }
      } catch (error) {
        console.error('[前端] 统一登录失败:', error)
        return {
          success: false,
          message: error.response?.data?.message || '登录失败，请检查网络连接'
        }
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    }
  }
}
</script>

<style scoped>
.unified-login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #667eea 100%);
  background-size: 400% 400%;
  animation: gradientShift 8s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.floating-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  top: 30%;
  right: 30%;
  animation-delay: 4s;
}

.shape-4 {
  width: 120px;
  height: 120px;
  bottom: 20%;
  left: 20%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.login-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  font-size: 2rem;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 600;
}

.login-header p {
  color: #606266;
  font-size: 0.9rem;
}

.login-form {
  margin-bottom: 20px;
}

.login-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.login-footer p {
  margin: 0;
  color: #606266;
  font-size: 0.9rem;
}

.login-footer a {
  color: #409EFF;
  text-decoration: none;
  font-weight: 500;
}

.login-footer a:hover {
  text-decoration: underline;
}

.user-type-hint {
  text-align: center;
}

.user-type-hint p {
  margin: 0;
  color: #909399;
  font-size: 0.8rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-card {
    padding: 30px 20px;
  }
  
  .login-header h2 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .unified-login-container {
    padding: 10px;
  }
  
  .login-card {
    padding: 25px 15px;
  }
  
  .login-header h2 {
    font-size: 1.6rem;
  }
}
</style>
